/*  Called whenever the upsell carousel exists in the DOM.
    – destroys any previous instance (so we don’t leak memory)
    – instantiates a fresh Swiper pointed at #collection-products-swiper   */

window.initCollectionSwiper = function () {
  if (window.collectionSwiper) window.collectionSwiper.destroy(true, true);

  /* nothing to do if the markup is not present (e.g. empty collection) */
  const root = document.querySelector("#collection-products-swiper");
  if (!root) return;

  window.collectionSwiper = new Swiper(root, {
    slidesPerView: 1,
    spaceBetween: 16,
    navigation: {
      nextEl: ".col-swiper-button-next",
      prevEl: ".col-swiper-button-prev",
    },
    pagination: false,
    watchOverflow: true,
  });
};

/* Run once on the first page load */
document.addEventListener("DOMContentLoaded", window.initCollectionSwiper);

// Relooad after every change in the drawer
document.addEventListener("cart:updated", window.initCollectionSwiper);